import { getJson } from "../../../lib/http";

export interface MonthlyBehavior {
  month: string; // YYYY-MM
  days: number;
  overall: number | null;
  distance_km: number;
  driving_ms: number;
}

/**
 * Calificación mes a mes de una unidad (GET /reports/behavior/monthly, fase 2:
 * ingredientes guardados por día). Vacío si el API todavía no lo tiene (404) o
 * si falla: el Informe del vehículo cae a la puntuación por semana.
 */
export async function fetchMonthlyBehavior(companyId: string, deviceId: string, months = 6): Promise<MonthlyBehavior[]> {
  try {
    const res = await getJson<{ months?: MonthlyBehavior[] }>("/reports/behavior/monthly", { deviceId, months, companyId }, undefined, {
      headers: { "x-company-id": companyId },
    });
    return (res.months ?? []).filter((m) => m.days > 0);
  } catch {
    return [];
  }
}
